import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function Why({ lang }: Props) {
  const tr = t[lang].why;

  return (
    <section className="section why">
      <h2 className="section-title">{tr.title}</h2>
      <div className="why-grid">
        {tr.items.map((item, i) => (
          <div className="why-card" key={i}>
            <span className="why-icon">{item.icon}</span>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
